<template>
  <div class="box">
    <div class="carousel-box">
      <div class="carousel">
        <el-carousel height="150px" autoplay class="text-box-parent" :append-to-body="true"
          :style="{ 'z-index': $store.state.index }">
          <el-carousel-item v-for="item in carouselImgList" :key="item.id">
            <div class="text-box" v-if="item.id === 1">
              <div class="one">掌动游戏</div>
              <div class="two">打造基于游戏的全产业链生态</div>
              <!-- <div class="three">业务模式</div> -->
            </div>
            <img style="width: 100%;height: 100%;" :src="windowWidth > 992 ? item.imgSrc : item.mobileImg" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="about">
      <div class="box">
        <div class="one">
          <div class="icon-title">
            <img src="../assets/titleIcon.png" alt="" />
          </div>
          <div class="title">关于掌动</div>
          <div class="icon-title">
            <img src="../assets/titleIcon.png" alt="" />
          </div>
        </div>
        <div class="two">ABOUT&nbsp;&nbsp;PALM</div>
        <!-- 资质标签 -->
        <div class="tag-group" style="margin: 30px  0 40px 0">
          <span class="tag-item">国家高新</span>
          <span class="tag-item">专精特新</span>
          <span class="tag-item">省级高新技术研发中心</span>
        </div>
        <div class="three">掌动致力于创造开放卓越的游戏生态</div>
        <div class="four">
          <div class="four-item">掌动科技成立于2013年6月，是一家致力于集自主研发、运营于一体的游戏全产业链的高科技互联网公司。在游戏产</div>
          <div class="four-item">业中具有顶尖的技术和丰富的资源，对游戏的各方面有深刻的认识和优势壁垒。公司秉承着“掌动科技，快乐生活”的理</div>
          <div class="four-item">念，致力于游戏生态全产业链打造，为中国游戏创造开放卓越的游戏生态。</div>
        </div>
        <div class="mobile-four">
          <div class="four-item">
            掌动科技成立于2013年6月，是一家致力于集自主研发、运营于一体的游戏全产业链的高科技互联网公司。
            在游戏产业中具有顶尖的技术和丰富的资源，对游戏各方面有深刻的认识和优势壁垒。
            <!-- 公司秉承着“掌动科技，快乐生活”的理念，致力于游戏生态全产业链打造，为中国游戏创造开放卓越的游戏生态。 -->
          </div>
        </div>
        <div class="five">
          <div class="five-item five-item-left">
            <div class="five-item-title">1.2亿</div>
            <div>掌动注册用户</div>
          </div>
          <div class="five-item five-item-right">
            <div class="five-item-title">100+</div>
            <div>掌动开发游戏IP数</div>
          </div>
          <!-- <div class="five-item">
            <div class="five-item-title">Top10</div>
            <div>杭州重点文化企业</div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 产品介绍 -->
    <div class="product" style="margin-top: 100px;">
      <div class="box">
        <div class="one">
          <div class="icon-title">
            <img src="../assets/titleIcon.png" alt="" />
          </div>
          <div class="title" >产品介绍</div>
          <div class="icon-title">
            <img src="../assets/titleIcon.png" alt="" />
          </div>
        </div>
        <div class="two">OUR&nbsp;&nbsp;PRODUCT</div>
        <div class="content">
          <div :class="{
            'content-top': true,
            active: BottomCurrentIndex === index,
          }" v-for="(item, index) in lunbo" :key="index">
            <div class="left">
              <img :src="item.imgSrc" alt="" />
            </div>
            <div class="right">
              <div class="right-text-box">
                <div class="right-title">{{ item.title }}</div>
                <div class="right-content">{{ item.content }}</div>
                <div class="more" @click="downFn(item)" :class="{ disabled: downloading }">
                  <i class="el-icon-download"></i>
                  <span>{{ downloading ? '正在下载' : '下载' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="content-bottom">
            <div @click="bottomBtn(index)" v-for="(item, index) in lunbo" :key="index" :class="{
              'content-bottom-item': true,
              active: BottomCurrentIndex === index,
            }">
              <img :src="item.iconImg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 商务合作 -->
    <div class="cooperation">
      <div class="box">
        <div class="textOne">CONTACT</div>
        <div class="textTwo">商务合作</div>
        <div class="btn">
          <div class="btn-box" @click="contactBtn">
            <div>联系我们</div>
            <div class="phone-icon">
              <img src="../assets/phone.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog @close="close" :modal="false" center title="请扫码下载" :visible="dialogVisible" width="20%">
      <div class="imgbox">
        <div class="image">
          <img :src="codeImg[BottomCurrentIndex].img" alt="">
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false,
      downloading: false,
      videoImg: [
        {
          pcImg: require('@/assets/newImg/别吃鸡/960x500.png'),
          mobileImg: require('@/assets/mobile/mobileVideo1.png')
        },
        {
          pcImg: require('@/assets/newImg/开心点点消.png'),
          mobileImg: require('@/assets/mobile/mobileVideo2.png')
        },
        {
          pcImg: require('@/assets/newImg/奔跑吧原始人.jpg'),
          mobileImg: require('@/assets/mobile/mobileVideo3.png')
        }
      ],
      pcvideo: {
        url1: require('@/assets/video/别吃鸡.mp4'),
        url2: require('@/assets/video/点点消.mp4'),
        url3: require('@/assets/video/奔跑吧原始人.mp4')
      },
      mobilevideo: {
        url1: require('@/assets/mobileVideo/别吃鸡.mp4'),
        url2: require('@/assets/mobileVideo/开心点点消.mp4'),
        url3: require('@/assets/mobileVideo/奔跑吧原始人.mp4')
      },
      mutedOneShow: false,
      mutedTwoShow: false,
      mutedThreeShow: false,
      carouselImgList: [
        { id: 2, imgSrc: require('../assets/lunbo/bannerx2.png'), mobileImg: require('../assets/mobile/mobileBanner2.png') },
        { id: 3, imgSrc: require('../assets/lunbo/banner2x2.png'), mobileImg: require('../assets/mobile/mobileBanner3.png') }
      ],
      lunbo: [
        {
          id: 5,
          iconImg: require('../assets/newImg/坦克神兵/icon.jpg'),
          imgSrc: require('../assets/newImg/坦克神兵/big.jpg'),
          title: '坦克神兵',
          content:
            '《坦克神兵》坦克神兵是一款以Roguelike类玩法为核心的像素游戏，通过不同的副本设计、多样的单位设计结合丰富的阵容组合与流派设计，打造不一样的坦克大战!游戏中坦克与无人机均有三大属性、五大体系，可以根据副本场景自由搭配组合，更有丰富的装备词条可以做出针对性配置，打造最适合你的阵容!'
        },
        {
          id: 4,
          iconImg: require('../assets/newImg/掌动游戏/icon.png'),
          imgSrc: require('../assets/newImg/掌动游戏/big.jpg'),
          title: '掌动游戏',
          content:
            '《掌动游戏》掌动游戏是一款专注手游与经典单机的聚合平台，汇集海量热门、精品及怀旧游戏资源，覆盖动作、角色扮演、休闲等全品类。支持极速下载、一键安装、云存档同步与智能推荐，界面简洁、操作便捷，安全无广告。为玩家打造一站式游戏宝库，随时随地畅享流畅游戏体验。'
        },
        {
          id: 1,
          iconImg: require('../assets/newImg/火星计划/hxjh_icon.png'),
          imgSrc: require('../assets/newImg/火星计划/hxjh.png'),
          title: '火星计划',
          content:
            '《火星计划》是一款星际题材的联机末日生存射击游戏，包含了穿越、冒险、解谜等多样的游戏元素，在游戏中玩家可以体验到不一样的畅快射击，刺激紧张的求生感受！更有丰富剧情，世界BOSS，萌宠佣兵，星际角斗场，多样枪械，不同手感，百搭技能，超高游戏性！'
        },
        {
          id: 3,
          iconImg: require('../assets/newImg/幻象忍者/icon补直角.png'),
          imgSrc: require('../assets/newImg/幻象忍者/1024x500.png'),
          title: '幻象忍者',
          content:
            '《幻象忍者》是一款闯关游戏。在游戏中玩家需要操作主角，想法设法的让他跳过关卡中的一个个障碍和陷阱，游戏中会出现一些难以通过的障碍，这个时候就需要利用一些有趣的特殊道具，利用玩家灵活的操作来通过关卡。在游戏中通过的关卡越多，玩家在排行榜中的排名就越高，在众多玩家中彰显自身的实力。'
        }
      ],
      index: 1,
      BottomCurrentIndex: 0,
      windowWidth: document.documentElement.clientWidth,
      codeImg: [
        {
          name: '掌动游戏',
          img: ''
        },
        {
          name: '火星计划',
          img: require('../assets/code/hxjh.png')
        },
        {
          name: '别吃鸡',
          img: ''
        },
        {
          name: '幻想忍者',
          img: ''
        }
      ]
    }
  },
  methods: {
    bottomBtn (index) {
      this.BottomCurrentIndex = index
    },
    leftPlayIconBtn () {
      console.log(11)
      this.mutedOneShow = true
      this.$refs.videoOne.play()
    },
    topPlayIconBtn () {
      this.mutedTwoShow = true
      this.$refs.videoTwo.play()
    },
    bottomPlayIconBtn () {
      this.mutedThreeShow = true
      this.$refs.videoThree.play()
    },
    contactBtn () {
      this.$router.push('/contact')
    },
    downFn (item) {
      if (this.downloading) return
      console.log(item)
      if (item.title !== '火星计划' && item.title !== '掌动游戏' && item.title !== '坦克神兵') {
        this.$message({
          showClose: true,
          message: '敬请期待',
          offset: 50,
          duration: 1000
        })
      } else if (item.title === '掌动游戏') {
        this.downloading = true
        window.open('https://www.zdjoys.com/zdyx.apk')
        // 延时4秒复原按钮
        setTimeout(() => {
          this.downloading = false
        }, 4000)
      } else if (item.title === '坦克神兵') {
        this.downloading = true
        window.open('https://www.zdjoys.com/tksb.apk')
        // 延时4秒复原按钮
        setTimeout(() => {
          this.downloading = false
        }, 4000)
      } else {
        window.open('https://www.taptap.cn/app/378080', '_blank')
      }
    },
    close () {
      this.dialogVisible = false
    }
  },
  created () {
    window.scrollTo(0, 0)
  }
}
</script>
<style lang="scss" scoped>
.box {
  padding: 50px 0 0 0;
}

.more.disabled {
  pointer-events: none;
  opacity: 0.75;
}

// pc端
@media (min-width: 992px) {
  .imgbox {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;

    .image {
      width: 200px;
      height: 200px;

      .img {
        width: 100%;
        height: 100%;
      }
    }
  }

  img {
    width: 100%;
    height: 100%;
  }

  // 轮播图
  .carousel-box {
    width: 100%;

    .carousel {
      width: 1400px;
      height: 500px;
      margin: 0 auto;

      ::v-deep .el-carousel__arrow {
        background-color: rgba(31, 45, 61, 0.5);
        font-weight: 700;
      }

      ::v-deep .el-carousel__container {
        height: 500px !important;
      }

      ::v-deep .el-carousel__button {
        background-color: #ff8714;
      }

      ::v-deep .el-carousel__indicators.el-carousel__indicators--horizontal {
        bottom: 40px;

        .el-carousel__button {
          width: 59px;
          height: 4px;
        }
      }

      .text-box-parent {
        position: relative;

        .text-box {
          position: absolute;
          z-index: 99;
          top: 50%;
          left: 150px;
          transform: translateY(-50%);

          .one {
            font-size: 30px;
            color: #29262d;
            margin-bottom: 15px;
            letter-spacing: 1px;
          }

          .two {
            font-size: 36px;
            color: #29262d;
            margin-bottom: 15px;
            letter-spacing: 2px;
          }

          .three {
            text-align: center;
            line-height: 30px;
            width: 100px;
            height: 30px;
            background-color: #ff8714;
            font-size: 14px;
            color: #fff;
            border-radius: 5px;
            cursor: pointer;
          }
        }
      }
    }
  }

  // 关于掌动
  .about {
    @media (min-width: 992px) {
      height: 500px;
    }

    display: flex;
    justify-content: center;

    @media (min-width: 992px) {
      .box {
        text-align: center;
        width: 1200px;

        .one {
          display: flex;
          justify-content: center;
          align-items: center;

          .icon-title {
            width: 20px;
            height: 33px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .title {
            text-align: center;
            line-height: 25px;
            font-size: 25px;
            color: #000000;
            margin: 0 8px;
          }
        }

        .two {
          color: #a7a7a7;
          font-size: 25px;
          font-family: Fontsstyle1;
          font-weight: 300;
          letter-spacing: 2px;
        }

        // 资质标签PC样式
        .tag-group {
          display: flex;
          justify-content: center;
          gap: 16px;
          margin: 16px 0 20px 0;

          .tag-item {
            background-color: #ffe3c8;
            color: #dd7a1d;
            padding: 8px 20px;
            border-radius: 999px;
            font-size: 18px;
            // 字体加粗
            font-weight: 600;

          }
        }

        .three {
          margin: 30px 0;
          font-size: 36px;
        }

        .four {
          font-size: 16px;

          .four-item:nth-child(2) {
            margin: 10px 0;
          }
        }

        .mobile-four {
          display: none;
        }

        .five {
          display: flex;
          justify-content: center;
          margin-top: 40px;

          // .five-item:nth-child(2) {
          //   margin: 0 00px;
          // }

          .five-item-left{
            margin-right:248px;
          }
          .five-item-title {
            color: #000000;
            font-size: 45px;
          }

          .five-item {
            font-size: 16px;
            // margin-left: 100px;
          }
        }
      }
    }
  }

  //产品介绍
  .product {
    display: flex;
    justify-content: center;
    height: 700px;

    .box {
      text-align: center;
      width: 100%;
      width: 1400px;
      padding: 0;

      .one {
        display: flex;
        justify-content: center;
        align-items: center;

        .icon-title {
          width: 20px;
          height: 33px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .title {
          text-align: center;
          line-height: 25px;
          font-size: 25px;
          color: #000000;
          margin: 0 8px;
        }
      }

      .two {
        color: #a7a7a7;
        font-size: 25px;
        font-family: Fontsstyle1;
        font-weight: 300;
        letter-spacing: 2px;
        margin-bottom: 40px;
      }

      .content {
        position: relative;

        .content-top {
          display: flex;
          height: 450px;
          display: none;

          &.active {
            display: flex;
          }

          .left {
            width: 960px;
            height: 100%;
          }

          .right {
            width: 600px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .right-text-box {
              margin-left: 180px;

              .right-title {
                line-height: 80px;
                height: 80px;
                font-size: 40px;
              }

              .line-box {
                display: flex;
                margin-left: 238px;

                .line1 {
                  width: 15px;
                  height: 3px;
                  margin-right: 10px;
                  background-color: #ff8714;
                }

                .line2 {
                  width: 60px;
                  height: 3px;
                  background-color: #ff8714;
                }
              }

              .right-content {
                text-align: left;
                margin-top: 10px;
                width: 434px;
                height: 200px;
                margin-left: -91px;
                text-indent: 2em !important;
                font-size: 15px;
              }

              .more {
                width: 100px;
                height: 40px;
                background-color: #ff8714;
                color: #fff;
                text-align: center;
                line-height: 40px;
                border-radius: 3px;
                font-size: 16px;
                cursor: pointer;

                &:hover {
                  background-color: rgba(255, 135, 20, 0.8);
                }

                span {
                  margin-left: 3px;
                }
              }
            }
          }
        }

        .content-bottom {
          display: flex;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 491px;

          .content-bottom-item {
            cursor: pointer;
            border-radius: 5px;
            width: 60px;
            height: 60px;
            margin-right: 20px;

            img {
              border-radius: 5px;
              object-fit: fill;
              width: 100%;
              height: 100%;
            }

            &.active {
              border: 2px solid #ff8714;
            }
          }
        }
      }
    }
  }

  //视频
  .video {
    display: flex;
    justify-content: center;
    height: 630px;

    .box {
      text-align: center;
      width: 100%;
      padding: 0;
      width: 1400px;

      .one {
        display: flex;
        justify-content: center;
        align-items: center;

        .icon-title {
          width: 20px;
          height: 33px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .title {
          text-align: center;
          line-height: 25px;
          font-size: 25px;
          color: #000000;
          margin: 0 8px;
        }
      }

      .two {
        color: #a7a7a7;
        font-size: 25px;
        font-family: Fontsstyle1;
        font-weight: 300;
        letter-spacing: 2px;
        margin-bottom: 40px;
      }

      .content {
        display: flex;
        justify-content: space-between;

        .left {
          position: relative;
          width: 857px;
          height: 500px;

          .left-bottom-shadow {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 50px;
            z-index: 99;
            background-color: rgba(20, 42, 61, 0.3);

            .title {
              color: #fff;
              font-size: 20px;
              text-align: left;
              line-height: 50px;
              font-weight: 300;
            }
          }

          .left-playIcon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100px;
            height: 100px;

            img {
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
          }
        }

        .right {
          margin-left: 10px;

          .right-top {
            width: 529px;
            height: 242px;
            margin-bottom: 15px;
            position: relative;

            .left-bottom-shadow {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 50px;
              z-index: 99;
              background-color: rgba(20, 42, 61, 0.3);

              .title {
                color: #fff;
                font-size: 16px;
                text-align: left;
                line-height: 50px;
                font-weight: 300;
              }
            }

            .left-playIcon {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 70px;
              height: 70px;

              img {
                width: 100%;
                height: 100%;
                cursor: pointer;
              }
            }
          }

          .right-bottom {
            width: 529px;
            height: 242px;
            position: relative;

            .left-bottom-shadow {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 50px;
              z-index: 99;
              background-color: rgba(20, 42, 61, 0.3);

              .title {
                color: #fff;
                font-size: 16px;
                text-align: left;
                line-height: 50px;
                font-weight: 300;
              }
            }

            .left-playIcon {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 70px;
              height: 70px;

              img {
                width: 100%;
                height: 100%;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  //商务合作
  .cooperation {
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: linear-gradient(to right top, #0d496c, #047895, #01bdb0);
    height: 300px;
    margin: 30px 0 50px 0;
    letter-spacing: 8px;

    .box {
      text-align: center;
      padding: 0;

      .textOne {
        font-size: 40px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
      }

      .textTwo {
        margin-top: -32px;
        font-size: 40px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }

      .btn {
        padding: 0;

        .btn-box {
          width: 127px;
          height: 30px;
          margin: 20px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #ff8714;
          color: #ffebd8;
          letter-spacing: 1px;
          font-size: 14px;
          border-radius: 3px;

          .phone-icon {
            width: 15px;
            height: 15px;
            margin: -8px 0 0 3px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .common-bottom {
    height: 250px;
    background-color: #ff8714;

    .box {
      text-align: center;
      padding-top: 60px;

      .line {
        width: 100%;
        height: 1px;
        background: linear-gradient(225deg, rgba(255, 255, 255, 0) 0%, #ffffff 51%, rgba(255, 255, 255, 0) 100%);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }

      .title {
        color: #ffebd8;
        font-size: 25px;
        margin: 20px 0;
      }

      .textOne {
        color: #ffebd8;
        font-size: 14px;
        margin-bottom: 15px;
      }

      .textTwo {
        color: #ffebd8;
        font-size: 14px;
      }
    }

    .mobile-box {
      display: none;
    }
  }
}

// 移动端
@media (max-width: 992px) {
  img {
    width: 100%;
    height: 100%;
  }

  ::v-deep .el-carousel__button {
    background-color: #ff8714;
  }

  .icon-title {
    display: none;
  }

  .carousel-box {
    .text-box-parent {}

    ::v-deep .el-carousel__container {}
  }

  .text-box-parent {
    position: relative;

    .text-box {
      position: absolute;
      z-index: 999;
      top: 50%;
      left: 69px;
      transform: translateY(-50%);

      .one {
        font-size: 12px;
        color: #191919;
        margin-bottom: 5px;
        font-weight: 500;
      }

      .two {
        font-size: 14px;
        color: #191919;
        margin-bottom: 5px;
        letter-spacing: 2px;
        font-weight: 500;
      }

      .three {
        text-align: center;
        line-height: 30px;
        width: 70px;
        height: 30px;
        background-color: #ff8714;
        font-size: 12px;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
      }
    }
  }

  .about {
    @media (max-width: 992px) {
      height: 250px;
    }

    display: flex;
    justify-content: center;

    .box {
      padding: 20px 0 0 0;
      text-align: center;

      .one {
        .title {
          font-size: 20px;
          color: #ff8714;
          position: relative;

          &::before {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #ff8714;
            top: 50%;
            transform: translateY(-50%);
            left: 36%;
          }

          &::after {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #ff8714;
            top: 50%;
            transform: translateY(-50%);
            right: 36%;
          }
        }
      }

      .two {
        color: #a7a7a7;
        font-size: 20px;
        font-family: Fontsstyle1;
        font-weight: 300;
      }

      //移动端标签样式
      .tag-group {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 8px;
        margin: 8px 0 10px 0;

        .tag-item {
         background-color: #ffe3c8;
          color: #dd7a1d;
          padding: 4px 10px;
          border-radius: 999px;
          font-size: 12px;
        }
      }

      .three {
        margin: 5px 0;
        font-size: 18px;
        color: #000000;
      }

      .four {
        display: none;
      }

      .mobile-four {
        font-size: 12px;

        .four-item {
          text-align: center;
          padding: 0 20px;
          text-indent: 2em;
          font-size: 12px;
        }

        .four-item:nth-child(2) {
          margin: 10px 0;
        }
      }

      .five {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        font-size: 12px;

        .five-item:nth-child(2) {
          margin: 0 25px;
        }

        .five-item-title {
          color: #000000;
          font-size: 20px;
        }
      }
    }
  }

  //产品介绍
  .product {
    img {
      width: 100%;
      height: 100%;
    }

    display: flex;
    justify-content: center;
    height: 280px;
    padding: 0 20px;

    .box {
      text-align: center;
      width: 100%;
      padding: 0;

      .one {
        .title {
          font-size: 20px;
          color: #ff8714;
          position: relative;

          &::before {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #ff8714;
            top: 50%;
            transform: translateY(-50%);
            left: 34.2%;
          }

          &::after {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #ff8714;
            top: 50%;
            transform: translateY(-50%);
            right: 34.2%;
          }
        }
      }

      .two {
        color: #a7a7a7;
        font-size: 20px;
        margin-bottom: 10px;
        font-family: Fontsstyle1;
        font-weight: 300;
      }

      .content {
        position: relative;

        .content-top {
          display: flex;
          height: 150px;
          display: none;

          &.active {
            display: flex;
          }

          .left {
            width: 595px;
            height: 100%;
          }

          .right {
            width: 278px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .right-text-box {
              .right-title {
                font-size: 20px;
                margin-bottom: 5px;
              }

              .line-box {
                display: flex;
                margin-left: 47px;

                .line1 {
                  width: 9px;
                  height: 1px;
                  margin-right: 10px;
                  background-color: #ff8714;
                }

                .line2 {
                  width: 30px;
                  height: 1px;
                  background-color: #ff8714;
                }
              }

              .right-content {
                display: none;
              }

              .more {
                margin: 0 auto;
                margin-top: 20px;
                width: 50px;
                height: 25px;
                background-color: #ff8714;
                color: #fff;
                text-align: center;
                line-height: 25px;
                border-radius: 2px;
                font-size: 12px;
                cursor: pointer;

                &:hover {
                  background-color: rgba(255, 135, 20, 0.8);
                }

                span {
                  margin-left: 1px;
                }
              }
            }
          }
        }

        .content-bottom {
          display: flex;
          position: relative;
          align-items: center;
          top: 20px;
          left: 6%;
          // transform: translateX(-50%);
          .content-bottom-item {
            width: 40px;
            height: 40px;
            margin-right: 10px;
            border-radius: 3px;
            display: flex;
            align-items: center;

            img {
              width: 38px;
              height: 38px;
            }

            &.active {
              border: 1px solid #ff8714;
            }
          }
        }
      }
    }
  }

  //游戏视频
  .video {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    padding: 0 20px 0 20px;

    .box {
      text-align: center;
      width: 100%;
      padding: 0;

      .one {
        .title {
          font-size: 20px;
          color: #ff8714;
          position: relative;

          &::before {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #ff8714;
            top: 50%;
            transform: translateY(-50%);
            left: 34.2%;
          }

          &::after {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #ff8714;
            top: 50%;
            transform: translateY(-50%);
            right: 34.2%;
          }
        }
      }

      .two {
        color: #a7a7a7;
        font-size: 20px;
        margin-bottom: 10px;
        font-family: Fontsstyle1;
        font-weight: 300;
      }

      .content {
        .left {
          position: relative;
          width: 100%;
          height: 500px;

          .left-bottom-shadow {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 30px;
            z-index: 999;
            background-color: rgba(20, 42, 61, 0.3);

            .title {
              color: #fff;
              font-size: 12px;
              text-align: left;
              line-height: 30px;
              font-weight: 300;
            }
          }

          .left-playIcon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 50px;
            height: 50px;

            img {
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
          }
        }

        .right {
          width: 100%;
          justify-content: space-between;
          margin-top: 15px;

          .right-top {
            width: 100%;
            height: 500px;
            margin-bottom: 15px;
            position: relative;

            .left-bottom-shadow {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 30px;
              z-index: 999;
              background-color: rgba(20, 42, 61, 0.3);

              .title {
                color: #fff;
                font-size: 12px;
                text-align: left;
                line-height: 30px;
                font-weight: 300;
              }
            }

            .left-playIcon {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 50px;
              height: 50px;

              img {
                width: 100%;
                height: 100%;
                cursor: pointer;
              }
            }
          }

          .right-bottom {
            width: 100%;
            height: 500px;
            position: relative;

            .left-bottom-shadow {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 30px;
              z-index: 999;
              background-color: rgba(20, 42, 61, 0.3);

              .title {
                color: #fff;
                font-size: 12px;
                text-align: left;
                line-height: 30px;
                font-weight: 300;
              }
            }

            .left-playIcon {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 50px;
              height: 50px;

              img {
                width: 100%;
                height: 100%;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  //商务合作
  .cooperation {
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: linear-gradient(to right top, #0d496c, #047895, #01bdb0);
    height: 150px;
    margin: 15px 0;
    letter-spacing: 4px;

    .box {
      text-align: center;
      padding: 0;

      .textOne {
        font-size: 20px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
      }

      .textTwo {
        margin-top: -16px;
        font-size: 20px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }

      .btn {
        .btn-box {
          width: 86px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #ff8714;
          color: #ffebd8;
          letter-spacing: 1px;
          font-size: 12px;
          border-radius: 3px;

          .phone-icon {
            width: 12px;
            height: 12px;
            margin: -8px 0 0 3px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .common-bottom {
    height: 150px;
    background-color: #ff8714;

    .box {
      display: none;
    }

    .mobile-box {
      padding: 24px 0 0 0;
      text-align: center;

      .line {
        width: 100%;
        height: 1px;
        background: linear-gradient(225deg, rgba(255, 255, 255, 0) 0%, #ffffff 51%, rgba(255, 255, 255, 0) 100%);
        opacity: 1;
      }

      .title {
        color: #ffebd8;
        font-size: 16px;
        margin: 5px 0;
      }

      .textOne {
        color: #ffebd8;
        font-size: 10px;
        transform: scale(0.83333);
      }

      .textTwo {
        color: #ffebd8;
        font-size: 10px;
        transform: scale(0.83333);
      }
    }
  }
}
</style>
